import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SingleDatePicker } from "react-dates";
import useCheckboxes from "../../Hooks/useCheckboxes";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import CourseSectionService from "../../../Services/CourseSection.service";
import LinkToPerson from "../Person/LinkToPerson/LinkToPerson";
import { AcademicCalendarMultiSearch } from "../AcademicCalendar/AcademicCalendarSearch";
import { StaffMultiSearch } from "../Person/StaffSearch";
import { CourseMultiSearch } from "../Course/CourseSearch";
import DateService from "../../../Services/Shared/Date.service";
import useUniqueId from "../../Hooks/useUniqueId";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
// @ts-expect-error - TS2739 - Type '{ id: string; name: string; }' is missing the following properties from type 'AcademicCalendarDto': displayName, startDate, endDate, year
const CURRENT_TERM = {
    id: "0",
    name: "Current Term",
};
const PAGE_SIZE = 20;
const SEARCH_DEFAULT = "";
// @ts-expect-error - TS7034 - Variable 'INSTRUCTORS_DEFAULT' implicitly has type 'any[]' in some locations where its type cannot be determined.
const INSTRUCTORS_DEFAULT = [];
const COURSES_DEFAULT = [];
const THIS_TERM_DEFAULT = [];
const CENSUS_DATE_FROM_DEFAULT = null;
const CENSUS_DATE_TO_DEFAULT = null;
const WITHDRAW_BY_DATE_FROM_DEFAULT = null;
const WITHDRAW_BY_DATE_TO_DEFAULT = null;
const DEFAULT_SEARCH = {
    query: SEARCH_DEFAULT,
    terms: THIS_TERM_DEFAULT,
    instructors: INSTRUCTORS_DEFAULT,
    courses: COURSES_DEFAULT,
    censusDateFrom: CENSUS_DATE_FROM_DEFAULT,
    censusDateTo: CENSUS_DATE_TO_DEFAULT,
    withdrawByDateFrom: WITHDRAW_BY_DATE_FROM_DEFAULT,
    withdrawByDateTo: WITHDRAW_BY_DATE_TO_DEFAULT,
};
const CourseSectionLookup = ({ selected: selectedCourseSections, defaultCourses, children, defaultTerms, }) => {
    var _a;
    const [query, setQuery] = React.useState(SEARCH_DEFAULT);
    const [terms, setTerms] = React.useState(defaultTerms || THIS_TERM_DEFAULT);
    const virtualizedAppContext = useVirtualizedApp();
    const [instructors, setInstructors] = React.useState(INSTRUCTORS_DEFAULT);
    const [censusDateFrom, setCensusDateFrom] = React.useState(CENSUS_DATE_FROM_DEFAULT);
    const [censusDateTo, setCensusDateTo] = React.useState(CENSUS_DATE_TO_DEFAULT);
    const [withdrawByDateFrom, setWithdrawByDateFrom] = React.useState(WITHDRAW_BY_DATE_FROM_DEFAULT);
    const [withdrawByDateTo, setWithdrawByDateTo] = React.useState(WITHDRAW_BY_DATE_TO_DEFAULT);
    const [courses, setCourses] = React.useState(defaultCourses || COURSES_DEFAULT);
    const [censusDateFromFocused, setCensusDateFromFocused] = React.useState(false);
    const [censusDateToFocused, setCensusDateToFocused] = React.useState(false);
    const [withdrawByDateFromFocused, setWithdrawByDateFromFocused] = React.useState(false);
    const [withdrawByDateToFocused, setWithdrawByDateToFocused] = React.useState(false);
    const [searchArgs, setSearchArgs] = React.useState(Object.assign(Object.assign({}, DEFAULT_SEARCH), { terms,
        courses }));
    const makeId = useUniqueId()[1];
    const searchItems = () => {
        setSearchArgs({
            query,
            terms,
            instructors,
            courses,
            censusDateFrom,
            censusDateTo,
            withdrawByDateFrom,
            withdrawByDateTo,
        });
    };
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedCourseSections || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const { table, dataState } = usePagedSortedTable({
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getData: (sort, page, sArgs) => {
            var _a, _b, _c, _d, _e, _f;
            return CourseSectionService.search({
                query: sArgs.query,
                academicCalendarIds: (_a = sArgs.terms) === null || _a === void 0 ? void 0 : _a.map((term) => term.id),
                instructorAffiliationIds: sArgs.instructors.map((instructor) => instructor.affiliationId),
                courseIds: (_b = sArgs.courses) === null || _b === void 0 ? void 0 : _b.map((course) => course.id),
                censusDateFrom: (_c = sArgs.censusDateFrom) === null || _c === void 0 ? void 0 : _c.toDate(),
                censusDateTo: (_d = sArgs.censusDateTo) === null || _d === void 0 ? void 0 : _d.toDate(),
                withdrawByDateFrom: (_e = sArgs.withdrawByDateFrom) === null || _e === void 0 ? void 0 : _e.toDate(),
                withdrawByDateTo: (_f = sArgs.withdrawByDateTo) === null || _f === void 0 ? void 0 : _f.toDate(),
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
            });
        },
        searchArgs,
        getNumPages: (result) => 
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No Course Sections found",
        columns: [
            {
                title: "Name",
                sortId: "name",
                size: 3,
            },
            {
                title: "Code",
                sortId: "code",
            },
            { title: "Section", sortId: "section", size: 1 },
            {
                title: "Instructor",
                sortId: "instructorAffiliation",
            },
            { title: "Term", sortId: "academicCalendar" },
            { title: "Census Date", sortId: "censusDate" },
            { title: "Withdraw By", sortId: "withdrawByDate" },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => data.map((courseSection) => {
            var _a, _b;
            return [
                courseSection.name,
                courseSection.code,
                courseSection.section,
                courseSection.instructor ? (_jsx(LinkToPerson, { affiliationId: (_a = courseSection.instructor) === null || _a === void 0 ? void 0 : _a.affiliationId, virtualizedApp: virtualizedAppContext.name, children: (_b = courseSection.instructor) === null || _b === void 0 ? void 0 : _b.fullName })) : (""),
                courseSection.isTermCurrent ? (_jsx("span", { className: "badge badge-success", title: "This is a current term", children: courseSection.termName })) : (courseSection.termName),
                courseSection.censusDate
                    ? DateService.displayLong(courseSection.censusDate)
                    : null,
                courseSection.withdrawByDate
                    ? DateService.displayLong(courseSection.withdrawByDate)
                    : null,
            ];
        }),
    });
    return children({
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
        lookup: (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "programSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "programSearch", placeholder: "Search Name, Code, Section", style: { width: 250, height: 38 }, value: query, onChange: (event) => {
                                        setQuery(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsx("div", { className: "form-group mr-3 mt-2 ", children: _jsx(StaffMultiSearch, { placeholder: "Instructor(s)", style: { width: 300 }, value: instructors, onChange: (val) => setInstructors(val), "aria-label": "Instructor(s)" }) }), _jsx("div", { className: "form-group mr-3 mt-2 ", children: _jsx(CourseMultiSearch, { placeholder: "Course(s)", style: { width: 300 }, value: courses, onChange: (val) => setCourses(val), "aria-label": "Course(s)" }) }), _jsx("div", { className: "form-group mr-3 mt-2 ", children: _jsx(AcademicCalendarMultiSearch, { placeholder: "Term(s)", style: { width: 300 }, value: terms, onChange: (val) => setTerms(val), additionalOptions: [CURRENT_TERM], "aria-label": "Terms(s)" }) }), _jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: makeId("updatedCensusFromDate"), className: "sr-only", children: "Census Date From" }), _jsx("label", { htmlFor: makeId("updatedCensusToDate"), className: "sr-only", children: "Census Date To" }), _jsxs("div", { className: "d-flex react-date-single-picker-group", id: "censusDateGroup", children: [_jsx(SingleDatePicker, { showClearDate: true, displayFormat: "M/D/YYYY", numberOfMonths: 1, 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: censusDateFrom, id: makeId("updatedCensusFromDate"), placeholder: "Census from", onDateChange: (date) => {
                                                if (!date && !censusDateFrom) {
                                                    return date;
                                                }
                                                setCensusDateFrom(date);
                                                if (censusDateTo && !censusDateTo.isAfter(date)) {
                                                    setCensusDateTo(date);
                                                }
                                                return date;
                                            }, focused: censusDateFromFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setCensusDateFromFocused(focused) }), _jsx(SingleDatePicker, { numberOfMonths: 1, showClearDate: true, displayFormat: "M/D/YYYY", id: makeId("updatedCensusToDate"), placeholder: "Census to", 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: censusDateTo, onDateChange: (date) => {
                                                if (!date && !censusDateTo) {
                                                    return date;
                                                }
                                                setCensusDateTo(date);
                                                if (censusDateFrom && !censusDateFrom.isBefore(date)) {
                                                    setCensusDateFrom(date);
                                                }
                                                return date;
                                            }, focused: censusDateToFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setCensusDateToFocused(focused) })] })] }), _jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: makeId("updatedWithdrawByFromDate"), className: "sr-only", children: "Withdraw By Date From" }), _jsx("label", { htmlFor: makeId("updatedWithdrawByToDate"), className: "sr-only", children: "Withdraw By Date To" }), _jsxs("div", { className: "d-flex react-date-single-picker-group", id: "withdrawByDateGroup", children: [_jsx(SingleDatePicker, { showClearDate: true, displayFormat: "M/D/YYYY", numberOfMonths: 1, 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: withdrawByDateFrom, id: makeId("updatedWithdrawByFromDate"), placeholder: "Withdraw from", onDateChange: (date) => {
                                                if (!date && !withdrawByDateFrom) {
                                                    return date;
                                                }
                                                setWithdrawByDateFrom(date);
                                                if (withdrawByDateTo && !withdrawByDateTo.isAfter(date)) {
                                                    setWithdrawByDateTo(date);
                                                }
                                                return date;
                                            }, focused: withdrawByDateFromFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setWithdrawByDateFromFocused(focused) }), _jsx(SingleDatePicker, { numberOfMonths: 1, displayFormat: "M/D/YYYY", showClearDate: true, id: makeId("updatedWithdrawByToDate"), placeholder: "Withdraw to", 
                                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                                            date: withdrawByDateTo, onDateChange: (date) => {
                                                if (!date && !withdrawByDateTo) {
                                                    return date;
                                                }
                                                setWithdrawByDateTo(date);
                                                if (withdrawByDateFrom &&
                                                    !withdrawByDateFrom.isBefore(date)) {
                                                    setWithdrawByDateFrom(date);
                                                }
                                                return date;
                                            }, focused: withdrawByDateToFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setWithdrawByDateToFocused(focused) })] })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
    });
};
export default CourseSectionLookup;
